import { API_URL } from 'configuration/urls';

export const trimAddress = ({ mainAddress, secondryAddress, storeConfig }) => {
  if (!secondryAddress) {
    return mainAddress
      .replace(/Street /gi, 'St ')
      .replace(/Court /gi, 'Crt ')
      .replace(`, ${storeConfig.country}`, '')
      .replace(`, ${storeConfig.countryAbv}`, '')
      .replace(`${storeConfig.state}`, '')
      .replace(`${storeConfig.stateIdentifier}`, '');
  } else {
    const main = mainAddress
      .replace(/Street /gi, 'St ')
      .replace(/Court /gi, 'Crt ');
    const secondry = secondryAddress
      .replace(/Street /gi, 'St ')
      .replace(/Court /gi, 'Crt ')
      .replace(`, ${storeConfig.city}`, '')
      .replace(`, ${storeConfig.country}`, '')
      .replace(`, ${storeConfig.countryAbv}`, '')
      .replace(`${storeConfig.state}`, '')
      .replace(`${storeConfig.stateIdentifier}`, '');

    return `${main}${secondry ? `, ${secondry}` : ''}`;
  }
};

const checkIfInsideRadiusApi = async ({ storeId, locationCoordinates }) => {
  const URL = `${API_URL}deliveryLocations/v1/checkIfInsideRadius`;

  const requestObj = {
    storeId,
    destinationLat: locationCoordinates.lat,
    destinationLong: locationCoordinates.lng,
  };
  const urlParams = new URLSearchParams(requestObj);
  const response = await fetch(`${URL}?${urlParams.toString()}`);
  const result = await response.json();
  return result;
};

export const getDeliveryCostFromApi = async (storeId, locationCoordinates) => {
  const result = await checkIfInsideRadiusApi({ storeId, locationCoordinates });
  const { data, errors = [] } = result;
  if (errors.length > 0) {
    return false;
  }
  const { deliveryInfo } = data;
  const { deliveryCost, isDeliverable, minOrderValue } = deliveryInfo;
  return { isDeliverable, deliveryCost, minOrderValue };
};

/**
 * Converts postcodeData address to Google Maps format structure
 * @param {Object} postcodeData - Postcode data object containing postcode, latitude, longitude, and address
 * @returns {Object} - Google Maps formatted structure with address_components and geometry
 */
export const convertPostcodeDataToGmapsFormat = (postcodeData) => {
  if (!postcodeData || !postcodeData.address) {
    return null;
  }

  const { address } = postcodeData;

  const addressComponents = [
    {
      long_name: address.line_1,
      short_name: address.line_1,
      types: ['street_address', 'premise'],
    },
    ...(address.line_2
      ? [
          {
            long_name: address.line_2,
            short_name: address.line_2,
            types: ['subpremise'],
          },
        ]
      : []),
    ...(address.town_or_city
      ? [
          {
            long_name: address.town_or_city,
            short_name: address.town_or_city,
            types: ['locality', 'postal_town'],
          },
        ]
      : []),
    ...(address.county
      ? [
          {
            long_name: address.county,
            short_name: address.county,
            types: ['administrative_area_level_1'],
          },
        ]
      : []),
    {
      long_name: postcodeData.postcode,
      short_name: postcodeData.postcode,
      types: ['postal_code'],
    },
    ...(address.district
      ? [
          {
            long_name: address.district,
            short_name: address.district,
            types: ['sublocality_level_1'],
          },
        ]
      : []),
  ];

  const gmaps = {
    formatted_address: address.formatted_address.filter(Boolean).join(', '),
    address_components: addressComponents,
    geometry: {
      location: {
        lat: postcodeData.latitude,
        lng: postcodeData.longitude,
      },
    },
  };

  return gmaps;
};
